export default __webpack_public_path__ + "static/media/product-page1.1d952463.png";